<template>
  <section class="row">
    <div class="col-12 col-lg-9 mx-auto">
      <v-radio
        input-id="option-financial"
        label="Sélectionnez votre niveau de protection"
        :list="options"
        path="risk.local.pertefinanciere.formule"
        module-name="contract"
        getter-name="get"
        :getter-function="getFormula"
        setter-name="updateSubscription"
        :setter-function="setRadioSubscription"
        :input-disabled="disabled"
      />
      <div class="d-flex flex-md-row flex-column flex-wrap mb-2 mb-md-4">
        <div
          class="d-flex flex-column col-md-6 col-12"
          :class="{'offset-md-6': formule === 'AVANTAGE' }"
        >
          <span
            v-for="(perk, index) in perksList"
            :key="perk"
            :class="{ 'text-gray-400' : index >= 3 && formule === 'STANDARD' }"
          >
            <font-awesome-icon
              :icon="['fas', index >= 3 && formule === 'STANDARD' ? 'times' : 'check' ]"
              :class="`text-${index >= 3 && formule === 'STANDARD' ? 'gray-400' : 'blue-500'}`"
              style="width: 16px"
            />
            {{ perk }}
          </span>
        </div>
      </div>
      <v-select
        input-id="local-financial-deductible"
        label="Votre franchise"
        :list="deductible"
        placeholder=""
        path="risk.local.pertefinanciere.deductible"
        module-name="contract"
        getter-name="get"
        :getter-function="getDeductible"
        setter-name="updateSubscription"
        :setter-function="setSelectSubscription"
        :input-validation="() => null"
        :disabled="disabled"
        class="mb-4"
      />
      <v-select
        input-id="local-financial-periode"
        label="Votre période d'indemnisation"
        :list="periode"
        placeholder=""
        path="risk.local.pertefinanciere.periode"
        module-name="contract"
        getter-name="get"
        :getter-function="getPeriode"
        setter-name="updateSubscription"
        :setter-function="setSelectSubscription"
        :input-validation="() => null"
        :disabled="disabled"
        class="mb-4"
      />
    </div>
  </section>
</template>
<script>
import { get } from 'lodash-es';
import { mapGetters } from 'vuex';

import Select from '@/components/common/input/CustomSelect2.vue';
import Radio from '@/components/common/input/Radio2.vue';

export default {
  components: {
    'v-select': Select,
    'v-radio': Radio,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        { name: 'Standard', value: 'STANDARD' },
        { name: 'Avantage', value: 'AVANTAGE' },
      ],
      deductible: [
        { name: '0 jour', code: 0 },
        { name: '3 jours', code: 3 },
        { name: '5 jours', code: 5 },
      ],
      periode: [
        { name: '12 mois', code: 12 },
        { name: '18 mois', code: 18 },
        { name: '24 mois', code: 24 },
        { name: '36 mois', code: 36 },
      ],
      perksList: [
        'Pertes d’exploitation',
        'Frais supplémentaires d’exploitation',
        'Impossibilité d’accès aux locaux',
        'Perte de valeur du fonds de commerce ',
        'Carence de fournisseurs ',
        'Désaffectation de clientèle ',
      ],
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    formule() {
      return this.getFormula(this.contract);
    },
  },
  methods: {
    getFormula(subscription) {
      return get(subscription, 'risk.local.pertefinanciere.formule', null);
    },
    getDeductible(subscription) {
      return get(subscription, 'risk.local.pertefinanciere.deductible', null);
    },
    getPeriode(subscription) {
      return get(subscription, 'risk.local.pertefinanciere.periode', null);
    },
    setRadioSubscription({ value }, path) {
      return { value, path };
    },
    setSelectSubscription({ code }, path) {
      return { value: code, path };
    },
  },
};
</script>
